










import { Vue, Component } from 'vue-property-decorator';
import MatrizBase from './MatrizBase.vue';

@Component({
  components: { MatrizBase },
})
export default class MatrizProductoPantalla extends Vue {}
